import api from '../services/api';

export interface ChatConversation {
  id: number;
  type: 'DIRECT' | 'GROUP';
  name: string;                  // other user's name for DIRECT, group name for GROUP
  avatar_letter: string;         // first letter for avatar
  last_message: string;
  last_by: string;
  last_at: string | null;
  message_count: number;
  unread_count: number;
  member_count?: number;         // for GROUP only
}

export interface ChatMessage {
  id: number;
  conversation_id: number;
  content: string;
  parent_id: number | null;
  is_pinned: boolean;
  created_by_id: number;
  created_at: string;
  updated_at: string;
  author: { id: number; name: string; email: string };
  replies?: ChatMessage[];
}

export interface ConversationDetail {
  id: number;
  type: 'DIRECT' | 'GROUP';
  name: string | null;
  created_by: number;
  members: Array<{ user_id: number; user: { id: number; name: string; email: string } }>;
}

export interface MessagingUser {
  id: number;
  name: string;
  email: string;
}

export const messagingApi = {
  getConversations: () =>
    api.get<ChatConversation[]>('/messaging/conversations').then(r => r.data),

  createConversation: (data: {
    type: 'DIRECT' | 'GROUP';
    user_id?: number;
    name?: string;
    member_ids?: number[];
  }) => api.post<{ id: number }>('/messaging/conversations', data).then(r => r.data),

  getConversation: (convId: number) =>
    api.get<ConversationDetail>(`/messaging/conversations/${convId}`).then(r => r.data),

  getMessages: (convId: number) =>
    api.get<ChatMessage[]>(`/messaging/conversations/${convId}/messages`).then(r => r.data),

  sendMessage: (convId: number, payload: { content: string; parent_id?: number }) =>
    api.post<ChatMessage>(`/messaging/conversations/${convId}/messages`, payload).then(r => r.data),

  pinMessage: (msgId: number, is_pinned: boolean) =>
    api.patch(`/messaging/messages/${msgId}/pin`, { is_pinned }).then(r => r.data),

  deleteMessage: (msgId: number) =>
    api.delete(`/messaging/messages/${msgId}`).then(r => r.data),

  markRead: (convId: number) =>
    api.post(`/messaging/conversations/${convId}/mark-read`).then(r => r.data),

  getUsers: () =>
    api.get<MessagingUser[]>('/messaging/users').then(r => r.data),

  addMember: (convId: number, userId: number) =>
    api.post(`/messaging/conversations/${convId}/members`, { user_id: userId }).then(r => r.data),

  removeMember: (convId: number, userId: number) =>
    api.delete(`/messaging/conversations/${convId}/members/${userId}`).then(r => r.data),

  getUnreadCount: () =>
    api.get<{ unread_count: number }>('/messaging/unread-count').then(r => r.data),
};
